export default function Impressum() {
  return (
    <main className="min-h-screen bg-[#020617] max-w-4xl mx-auto px-6 py-16" aria-labelledby="impressum-heading">
      <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
        <h1 id="impressum-heading" className="text-3xl md:text-4xl font-semibold mb-8">
          Impressum
        </h1>

        <div className="prose prose-lg max-w-none">
          <h2 className="text-2xl font-semibold mb-4">Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG)</h2>
          <p className="mb-4">
            <strong>Abschlepp- und Bergungsdienst Schiek e. K.</strong>
            <br />
            Inhaber: Ahmad Ayyach
            <br />
            Reinickendorfer Str. 87
            <br />
            13347 Berlin
            <br />
            Deutschland
          </p>

          <h2 className="text-2xl font-semibold mb-4 mt-8">Kontakt</h2>
          <p className="mb-4">
            Telefon:{' '}
            <a href="tel:+4917655677271" className="hover:underline">
              0176 55 677 271
            </a>
            <br />
            E-Mail:{' '}
            <a href="mailto:info@abschleppdienst-schiek.de" className="hover:underline">
              info@abschleppdienst-schiek.de
            </a>
            <br />
            Website:{' '}
            <a href="https://www.abschleppdienst-schiek.de" className="hover:underline">
              www.abschleppdienst-schiek.de
            </a>
          </p>

          <h2 className="text-2xl font-semibold mb-4 mt-8">Handelsregister</h2>
          <p className="mb-4">
            Registergericht: Amtsgericht Charlottenburg (Berlin)
            <br />
            Handelsregisternummer: HRA 66009
          </p>

          <h2 className="text-2xl font-semibold mb-4 mt-8">Umsatzsteuer-Identifikationsnummer</h2>
          <p className="mb-4">
            Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:
            <br />
            DE366665744
          </p>

          <h2 className="text-2xl font-semibold mb-4 mt-8">Verbraucherstreitbeilegung</h2>
          <p className="mb-8">
            Wir sind nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2 className="text-2xl font-semibold mb-4 mt-8">Haftung für Inhalte</h2>
          <p className="mb-4">
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten
            nach den allgemeinen Gesetzen verantwortlich.
          </p>

          <h2 className="text-2xl font-semibold mb-4 mt-8">Haftung für Links</h2>
          <p className="mb-4">
            Soweit diese Website Links zu externen Websites Dritter enthält, haben wir auf deren
            Inhalte keinen Einfluss. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
            Anbieter oder Betreiber verantwortlich.
          </p>

          <h2 className="text-2xl font-semibold mb-4 mt-8">Urheberrecht</h2>
          <p className="mb-4">
            Die auf dieser Website veröffentlichten Inhalte, Texte, Fotos und Gestaltungen
            unterliegen dem deutschen Urheberrecht, soweit nicht anders gekennzeichnet.
          </p>

          <div className="mt-12 pt-8 border-t-2 border-slate-900">
            <p className="text-sm opacity-70">Stand: Oktober 2026</p>
          </div>
        </div>
      </div>
    </main>
  );
}
